import React from 'react';
import {useTheme} from '../../theme';
import {Layout} from '../layout';
import {ProgressCircleSvg} from './ProgressCircleSvg';
import {ProgressCircleProps} from './types';

export const ProgressCircle: React.FC<ProgressCircleProps> = ({
  percentageProgress,
  kind,
  size,
}) => {
  const theme = useTheme();
  const progressColor =
    kind === 'Positive'
      ? theme.colors['border_positive_default']
      : kind === 'Warning'
      ? theme.colors['border_warning_default']
      : theme.colors['border_negative_default'];

  return (
    <Layout width={size} height={size}>
      <ProgressCircleSvg
        size={theme.spacing[size]}
        progress={percentageProgress}
        backgroundColor={theme.colors['border_mono_10']}
        progressColor={progressColor}
      />
    </Layout>
  );
};
